import { Link } from "react-router-dom";
import React from "react";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-content-holder">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="footer-content">
                <div className="footer-content-left">
                  <div className="footer-content-logo">
                    <img src="/images/fuka-logo-white.png" alt="Fuka" />
                    <div className="footer-content-logo-text">
                      ©2025 Fuka.rs, Izrada{" "}
                      <a
                        href="https://www.enio.rs"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Enio.
                      </a>{" "}
                      Sva prava zadržana.
                    </div>
                  </div>
                </div>
                <div className="footer-content-menu">
                  <ul>
                    <li>
                      <Link to="/delivery">{t("other.footer_delivery")}</Link>
                    </li>
                    <li>
                      <Link to="/payment-methods">
                        {t("other.footer_payment")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/privacy-policy">
                        {t("other.footer_privacy")}
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="footer-content-right">
                  <div className="footer-content-right-icons">
                    <div className="footer-icon">
                      <a
                        href="https://www.instagram.com/fuka.bg/?hl=en"
                        target="_blank"
                      >
                        <img src="/images/instagram.png" alt="Instagram" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="footer-content-bank">
                <a href="https://www.raiffeisenbank.rs" target="_blank">
                  <img
                    src="/images/raiffeisen-logo.png"
                    alt="Raiffeisen Banka"
                    className="height-logo"
                  />
                </a>
                <a
                  href="https://rs.visa.com/run-your-business/small-business-tools/payment-technology/visa-secure.html"
                  target="_blank"
                >
                  <img
                    src="/images/visa-secure.png"
                    className="height-logo"
                    alt="Visa Secure"
                  />
                </a>
                <a
                  href="https://rs.visa.com/run-your-business/small-business-tools/payment-technology/visa-secure.html"
                  target="_blank"
                >
                  <img
                    src="/images/visa.png"
                    className="height2-logo"
                    alt="Visa"
                  />
                </a>
                <a
                  href="https://www.mastercard.rs/sr-rs/korisnici/podrska/sigurnost-i-zastita/identity-check.html"
                  target="_blank"
                >
                  <img
                    src="/images/mc_idcheck.png"
                    className="height-logo"
                    alt="MasterCard Identity Check"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
